import { searchAssistantStore, searchAssistantUIStore } from '@/stores/searchAssistantStore';
import { Close, Menu } from '@mui/icons-material';
import { Box, CircularProgress, IconButton, Typography } from '@mui/material';

import { useCreateSessionWithStateUpdate } from '@/components/SearchAssistant/hooks/useChatData';
import AddIcon from '@mui/icons-material/Add';

const styles = {
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: (theme) => theme.spacing(1),
    borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
    backgroundColor: (theme) => theme.palette.baseColors?.deepSeaNavy?.c100,
  },
  headerTitle: {
    pointerEvents: 'none',
    display: 'inline-block',
    marginLeft: (theme) => theme.spacing(1),
    fontWeight: 600,
    color: 'white',
  },
  iconButton: {
    color: 'white',
    opacity: 0.7,
    '&:hover': {
      color: 'white',
      opacity: 1,
    },
  },
  newChatButton: {
    color: (theme) => theme.palette.baseColors.fireOrange.c100,
  },
};

const SidebarToggleButton = () => {
  const isSidebarOpen = searchAssistantUIStore((state) => state.isSidebarOpen);
  const toggleSidebar = searchAssistantUIStore.use.toggleSidebar();

  return (
    <IconButton
      onClick={toggleSidebar}
      size="small"
      sx={styles.iconButton}
      title={isSidebarOpen ? 'Hide Sessions' : 'Show Sessions'}
    >
      <Menu fontSize="small" />
    </IconButton>
  );
};

const ChatSessionTitle = () => {
  const chatSessionTitle = searchAssistantStore((state) => state.getCurrentSession()?.displayTitle);

  return (
    <Typography variant="body1" component="div" sx={styles.headerTitle}>
      {chatSessionTitle || 'Untitled Chat'}
    </Typography>
  );
};

const CloseChatButton = () => {
  const toggleOpen = searchAssistantUIStore.use.toggleOpen();

  return (
    <IconButton onClick={toggleOpen} size="small" sx={styles.iconButton}>
      <Close fontSize="small" />
    </IconButton>
  );
};

const CreateNewSessionButton = () => {
  const createSession = useCreateSessionWithStateUpdate();
  const creatingSession = searchAssistantStore.use.creatingSession();

  return (
    <IconButton
      size="small"
      onClick={createSession}
      sx={styles.newChatButton}
      title="New Chat"
      disabled={creatingSession}
    >
      {creatingSession ? <CircularProgress size={20} /> : <AddIcon />}
    </IconButton>
  );
};

const ChatHeader = () => {
  return (
    <Box as="header" sx={styles.header}>
      <div>
        <CloseChatButton />
        <SidebarToggleButton />
        <ChatSessionTitle />
      </div>
      <CreateNewSessionButton />
    </Box>
  );
};

export { ChatHeader };
